<!-- This is how to structure the menu -->
<ng-template
	#menuStructureTemplate
	let-dropdownMenuComponent="dropdownMenuComponent"
	let-menuOptions="menuOptions"
>
	@for(menuOption of menuOptions; track menuOption.id) {
	<div class="dropdown-menu-option">
		<ng-container
			*ngTemplateOutlet="
					optionDisplayTemplate;
					context: {
						menuOption: menuOption,
						dropdownMenuComponent: dropdownMenuComponent,
					}
				"
		>
		</ng-container>
	</div>
	}
</ng-template>
<!-- This is how to render each menu option -->
<ng-template
	#optionDisplayTemplate
	let-dropdownMenuComponent="dropdownMenuComponent"
	let-menuOption="menuOption"
>
	<label
		[for]="menuOption.id"
		(click)="
			dropdownMenuComponent.handleSingleSelect(menuOption);
			dropdownMenuComponent.toggleMenu()
		"
		>{{ Loc(menuOption.label) }}</label
	>
</ng-template>

<div #cf_overview_stage class="cf_overview_stage">
	<div class="cf_overview_stage-title">
		<label class="cf_overview_stage-title-label">{{ title }}</label>
		<div class="cf_overview_stage-title-dropdown">
			<dropdown-menu
				label="{{ dropdownValue }}"
				defaultValue="{{ dropdownValue }}"
				[menuOptions]="sectorOptions"
				[menuStructureTemplate]="menuStructureTemplate"
				[optionDisplayTemplate]="optionDisplayTemplate"
				(select)="handleSectorSelectedEvent($event)"
			>
			</dropdown-menu>
		</div>
	</div>
	<div class="cf_overview_stage-bubbles">
		<div
			class="cf_overview_stage-bubbles-line"
			[ngStyle]="bubbleLineStyle"
		></div>

		@for(stageCount of activeStageCounts; track stageCount.stage){
		<div>
			<div
				class="cf_overview_stage-bubbles-bubble"
				[ngStyle]="getBubbleStyles(stageCount, $index)"
				title="{{ getTooltip(stageCount) }}"
				(click)="handleClick(stageCount, true)"
			></div>
		</div>
		}
	</div>
	<div class="cf_overview_stage-details">
		<div class="cf_overview_stage-details-content">
			@for(stageCount of nonZeroStageCounts; track stageCount.stage){
			<div>
				<div
					class="cf_overview_stage-details-content-item"
					(click)="handleClick(stageCount, false)"
				>
					<div class="cf_overview_stage-details-content-item-label">
						{{ stageCount.stage }}
					</div>
					<div class="cf_overview_stage-details-content-item-count">
						{{ stageCount.count }}
					</div>
				</div>
			</div>
			}
		</div>
	</div>
</div>
